/**
 * The public registration page's URL shapes.
 *
 * Marketing shares `https://app.elyxeer.com/live/<slug>` — a real path, because a `#`
 * in a printed link looks broken. The hosted app rewrites every path to `index.html`
 * (Firebase) and the router is hash-based, so before React mounts the path is folded
 * into the hash route the bundle actually serves, with the query string kept: the
 * confirmation e-mail's `?t=<token>` is the whole point of the page.
 */

export const LIVE_PATH_PREFIX = "/live/";
export const LIVE_ROUTE_PATH = "/live/:slug";
export const LIVE_TOKEN_PARAM = "t";

const SLUG = /^[a-z0-9]+(-[a-z0-9]+)*$/;

/** The in-app route for a slug, or null when the slug is not one the API would mint. */
export function liveRouteFor(slug: string): string | null {
  return SLUG.test(slug) ? `${LIVE_PATH_PREFIX}${slug}` : null;
}

function routeFromPath(pathname: string): string | null {
  const match = pathname.match(/^\/live\/([^/]+)\/?$/);
  if (!match) return null;
  try {
    return liveRouteFor(decodeURIComponent(match[1]));
  } catch {
    return null;
  }
}

/**
 * Convert a directly requested `/live/<slug>` into the hash route, keeping the query.
 * Runs before React mounts, so the page is the first painted frame.
 */
export function normalizeDirectLiveLocation(): void {
  const route = routeFromPath(window.location.pathname);
  const hashPath = window.location.hash.replace(/^#/, "").split("?", 1)[0];
  if (!route || routeFromPath(hashPath)) return;
  window.history.replaceState(
    window.history.state,
    "",
    `/#${route}${window.location.search}`,
  );
}
